import React, {useEffect} from "react";
import _ from "lodash";

import {WorkflowInput} from "common/flowmaster/types/workflow";

import {Schema} from "common/flowmaster/types/schema";
import SchemaEditor from "../editors/schema_editor";

interface SchemaInputEditorProps {
  input: WorkflowInput;
  value: object;
  fullWidth: boolean;
  handleInputChange: (e: React.ChangeEvent<{value: object}>) => void;
  handleInputBlur: () => void;
  isInIssueEditor?: boolean;
  warning: boolean;
}

const initialSchema: Schema = {
  name: "",
  description: "",
  parameters: {
    type: "object",
    properties: {},
    required: [],
  },
};

const SchemaInputEditor: React.FC<SchemaInputEditorProps> = ({
  input,
  value,
  fullWidth,
  handleInputChange,
  handleInputBlur,
  isInIssueEditor = false,
  warning = false,
}) => {
  const argValue = _.isEmpty(value)
    ? {value: initialSchema}
    : {value: value as Schema};

  const handleChildSchemaEditorChange = ({value}: {value: Schema}) => {
    const event = {
      target: {
        value,
      },
    } as React.ChangeEvent<{value: object}>;
    handleInputChange(event);
  };

  useEffect(() => {
    // sync new values when switching issues
    handleInputBlur();
  }, [JSON.stringify(value)]);

  return (
    <div
      style={{
        ...(fullWidth ? {width: "100%"} : {}),
        display: "flex",
        flexDirection: "column",
        gap: "0.5em",
      }}
    >
      {input.label && (
        <span style={{color: "grey", marginBottom: "0.5em"}}>
          {input.label}
        </span>
      )}
      <div
        style={{
          border: `1px solid ${warning ? "orange" : "lightgrey"}`,
          borderRadius: "2px",
        }}
      >
        <SchemaEditor
          argValue={argValue}
          onUpdateItem={handleChildSchemaEditorChange}
          useDataStoreProperties={false}
          showNameEditor={!isInIssueEditor}
          showDescriptionEditor={!isInIssueEditor}
        />
      </div>
    </div>
  );
};

export default {
  label: "Schema",
  component: SchemaInputEditor,
  default: initialSchema,
};
